import React from 'react';
import style from './style.scss';

const OrPicker = (PickerComponents) => {
  return (props) => {
    const { id: _, value, onChange, ...rest } = props;
    if (value && value.type) {
      const Picker = PickerComponents[value.type];
      return (
        <div className={style.picker} {...rest}>
          <Picker
            value={value.id}
            onChange={v => v === null
              ? onChange(null)
              : onChange({ type: value.type, id: v })}
          />
        </div>
      );
    }
    return (
      <div className={style.picker} {...rest}>
        {Object.keys(PickerComponents).reduce((s, type) => [
          ...[s.length ? [s, ' or '] : []],
          (() => {
            const Picker = PickerComponents[type];
            return (<Picker
              onChange={id => onChange({ type, id })}
            />);
          })()
        ], [])}
      </div>
    );
  };
};

export default OrPicker;



// WEBPACK FOOTER //
// ./app/components/OrPicker/index.js